<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.displayName"
              label="角色名称"
              removable
              :messages="message"
              :error="!!error.displayNameErrors.length"
              :error-messages="error.displayNameErrors"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.name"
              label="角色代码"
              removable
              :messages="message"
              :error="!!error.nameErrors.length"
              :error-messages="error.nameErrors"
            />
          </div>
          <div class="flex md4 sm6 xs12">
            <va-input
              v-model="insertData.level"
              label="角色等级"
              removable
              type="number"
              placeholder="数字越大越靠前"
              :messages="message"
              :error="!!error.levelErrors.length"
              :error-messages="error.levelErrors"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.description"
              label="描述"
              type="textarea"
              removable
              :messages="message"
              :error="!!error.descriptionErrors.length"
              :error-messages="error.descriptionErrors"
            />
          </div>
        </div>
        <div class="row justify--center">
          <va-button class="flex md1" color="info" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            保存
          </va-button>
          <va-button class="flex md1" color="gray" slot="trigger" @click="$router.push({ name: 'listRole'})" :disabled="!submitButtonStatus">
            返回
          </va-button>
        </div>
      </va-card>
    </div>
    <div class="flex xs10 offset--xs1" v-show="showPermissions">
      <va-card title="权限列表">
        <div class="row" v-for="permissions in permissionGroupByBusiness" :key="permissions.businessId">
          <div class="flex md12 xs12 justify--start align-center ">
            <va-button flat small class="mb2">{{permissions.displayName}}:</va-button>
          </div>
          <div
            class="flex md2 xs12 justify--center permission-label offset--xs1"
            v-for="permission in permissions.permissions"
            :key="permission.id"
          >
            <label class="flex">
              <input
                type="checkbox"
                :value="permission.id"
                v-model="rolePermissions"
                :key="permission.id"
              />
              {{permission.displayName}}
            </label>
          </div>
        </div>
        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="submitAllPermissions" :disabled="!submitButtonStatus">
            保存权限
          </va-button>
        </div>
      </va-card>
    </div>
  </div>

</template>

<script>

import 'vue-trix'
import { copyObject } from '../../utils/common'
import roleApi from '../../api/role'
import permissionApi from '../../api/permission'
export default {
  data () {
    return {
      insertData: {
        id: null,
        name: '',
        displayName: '',
        description: '',
        level: null,
      },
      rolePermissions: [],
      allPermissions: [],
      message: ['Required field'],
      error: {
        nameErrors: [],
        displayNameErrors: [],
        descriptionErrors: [],
        levelErrors: [],
      },
      showId: false,
      title: '新增角色',
      submitButtonStatus: true,
      loading: true,
      showPermissions: false,
      permissionMap: {},
      permissionIds: [],
      permissionGroupByBusiness: [],
      test: [],
    }
  },
  created () {
    this.getRole()
    this.listRolePermission()
    this.listPermissionGroupByBusiness()
  },
  computed: {
    fields () {
      return [
        {
          name: 'displayName',
          title: '权限名称',
          width: '20%',
        },
        {
          name: 'description',
          title: '权限描述',
          width: '20%',
        },
        {
          name: 'businessName',
          title: '业务类型',
          width: '20%',
        },
        {
          name: 'action',
          title: '权限action代码',
          width: '20%',
        },
        {
          name: 'createTime',
          title: '创建时间',
          width: '20%',
        },
        {
          name: '__slot:actions',
          width: '20%',
          dataClass: 'text-left',
        },
      ]
    },
    formReady () {
      return !this.error.nameErrors.length &&
          !this.error.descriptionErrors.length &&
          !this.error.levelErrors.length &&
          !this.error.displayNameErrors.length
    },
  },
  methods: {
    getRole () {
      const params = this.$route.params
      if (params.id != null) {
        this.showId = true
        this.title = '编辑角色'
        // 通过id获取详情
        roleApi.getRole(params.id).then(response => {
          copyObject(response.role, this.insertData)
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    listRolePermission () {
      const params = this.$route.params
      if (params.id != null) {
        this.showPermissions = true
        roleApi.listRolePermissions(params.id).then(response => {
          this.rolePermissions = []
          response.permissions.forEach(permission => {
            this.rolePermissions.push(permission.id)
            this.permissionMap[permission.id] = true
          })
          this.loading = false
        }).catch(error => {
          this.loading = false
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    listPermissionGroupByBusiness () {
      permissionApi.listPermissionGroupByBusiness().then(response => {
        this.allPermissions = []
        this.permissionGroupByBusiness = response.permissionGroupByBusiness
        this.permissionGroupByBusiness.forEach(permissions => {
          permissions.permissions.forEach(permission => {
            this.permissionMap[permission.id] = false
            this.allPermissions.push(permission.displayName)
          })
        })
        this.listRolePermission()
      }).catch(error => alert(error))
    },
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      this.changeButtonStatus(false)
      const data = {
        name: this.insertData.name,
        displayName: this.insertData.displayName,
        description: this.insertData.description,
        level: this.insertData.level,
      }
      if (this.insertData.id != null) {
        data.id = this.insertData.id
        roleApi.updateRole(data).then(response => {
          if (response.success === true) {
            this.showToast('更新角色成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.changeButtonStatus(true)
            this.getRole()
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      } else {
        roleApi.createRole(data).then(response => {
          if (response.success === true) {
            this.showToast('添加角色成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'updateRole', path: `updateRole/${response.id}`, params: { id: response.id } })
            this.getRole()
            this.listRolePermission()
            this.changeButtonStatus(true)
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickCancel () {
    },
    checkField () {
      this.error.nameErrors = this.insertData.name ? [] : ['name is required']
      this.error.displayNameErrors = this.insertData.displayName ? [] : ['displayName is required']
      this.error.levelErrors = this.insertData.level ? [] : ['level is required']
      this.error.descriptionErrors = this.insertData.description ? [] : ['description is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
    submitAllPermissions () {
      this.changeButtonStatus(false)
      const data = {
        roleId: this.$route.params.id,
        permissionIds: this.rolePermissions,
      }
      roleApi.assignAllPermissions(data).then(response => {
        if (response.success === true) {
          this.showToast('保存权限成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listRolePermission()
          this.changeButtonStatus(true)
        }
      }).catch(error => {
        this.changeButtonStatus(true)
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
  },
}

</script>

<style>
.permission-label {
  cursor: pointer;
}
</style>
